import React from 'react';

interface OverlayProps {
  isVisible: boolean;
  onClick?: () => void;
  className?: string;
}

export const Overlay: React.FC<OverlayProps> = ({
  isVisible,
  onClick,
  className = ''
}) => {
  if (!isVisible) return null;

  return (
    <div
      onClick={onClick}
      className={`
        fixed inset-0
        min-h-screen
        bg-black/60
        backdrop-blur-[2px]
        ${className}
      `}
      style={{ height: '100vh' }}
    />
  );
};

export default Overlay; 